/* file description */
import * as React from 'react';
import { Space, Swiper, Image, Card, Button, SearchBar, CheckList, Popup, Input } from 'antd-mobile';
import { useMemo, useState } from 'react';
import styles from './index.module.less';
import { MobileInput } from '../../component/MobileInput';
import * as _ from 'lodash';
import { CheckCircleFill, CheckCircleOutline } from 'antd-mobile-icons';
import { Form } from 'antd';

interface MobileSelectProps {
  value: string | number | undefined | string[];
  options: Array<Record<string, any>>;
  onChange: (value: string | number | string[]) => void;
  disabled?: boolean;
  fieldNames?: {
    label: string;
    value: string;
  };
  mode?: 'multiple';
}


export const MobileSelect: React.FC<MobileSelectProps> = ({
  value,
  options,
  onChange,
  disabled,
  fieldNames,
  mode,
  ...otherProps
}) => {

  
  const [cascaderVis, seCascaderVis] = useState(false);
  const [searchText, setSearchText] = useState('');
  const multipleMode = mode === 'multiple';
  const showLabel = fieldNames?.label || 'label';
  const showValue = fieldNames?.value || 'value';


  const filteredItems = useMemo(() => {
    if (searchText) {
      return options.filter((item) => item[showLabel].includes(searchText));
    } else {
      return options;
    }
  }, [options, searchText]);


  const showInputVal = useMemo(() => {
    if (_.isArray(value)) {
      const labelArr: string[] = [];
      value.forEach((val) => {
        const resultOption = options.find((item) => item[showValue] === val);
        if (resultOption) {
          labelArr.push(resultOption?.[showLabel] || '');
        }
      });
      return labelArr.join(',');
    }

    return options.find((item) => item[showValue] === value)?.[showLabel];
  }, [options, value]);


  return (
    <>
      <MobileInput
        value={showInputVal}
        onClick={() => seCascaderVis(true)}
        disabled={disabled}
      />
      <Popup
        visible={cascaderVis}
        onMaskClick={() => {
          seCascaderVis(false);
        }}
        destroyOnClose
      >
        {
          multipleMode && (
          <div className={styles['tool-bar']}>
            <Button color="primary" fill="none" onClick={() => seCascaderVis(false)}>
              取消
            </Button>
            <Button color="primary" fill="none" onClick={() => seCascaderVis(false)}>
              确定
            </Button>
          </div>
          )
        }

        <div className={styles.searchBarContainer}>
          <SearchBar
            placeholder="输入文字过滤选项"
            value={searchText}
            onChange={(v) => {
              setSearchText(v);
            }}
          />
        </div>
        <div className={styles.checkListContainer}>
          <CheckList
            multiple={multipleMode}
            value={_.isArray(value) ? value : [value]}
            onChange={(val) => {
              const value = multipleMode ? val : val[0];
              onChange(value);
              !multipleMode && seCascaderVis(false);
            }}
            extra={(active) =>
              (active ? <CheckCircleFill /> : null)
            }
          >
            {filteredItems.map((item, index) => (
              <CheckList.Item key={`${item[showValue]}+${item[showLabel]}`} value={item[showValue]}>
                {item[showLabel]}
              </CheckList.Item>
            ))}
          </CheckList>
        </div>
      </Popup>
    </>
  );
};
